//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        data(){
            return {
                loginName:''
            }
        },
        mounted(){
            this.loginName = this.$route.query.loginName
        },
        methods: {
            btnBack(){
                this.$router.push("/index")
            },
            loginInfo(){
                this.$router.push("/login")
            }
        },
        
    }



// WEBPACK FOOTER //
// ./src/view/cupLoginTip.vue